import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { PaymentService } from 'src/app/services/payment.service';
import { Provider } from './../../../models/provider';
import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.scss']
})
export class ProvidersComponent implements OnInit {

  @Input() Providers: Provider[];
  public providersName: string;

  constructor(
    public paymentService: PaymentService,
    public titleService: Title,
    public activatedRoute: ActivatedRoute,
    private metaService: Meta,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      let { id } = params;
      id = id ? id : "NULL";
      this.paymentService.ProviderDetails(id).subscribe(response => {
        this.translate.get('Title').subscribe(({ homePageTitle, ogTitle }) => {
          const title = id == "NULL" ? homePageTitle : response.Name;
          this.titleService.setTitle(title);
          this.setMetaTags(ogTitle);
        });
        this.providersName = response.Name;
      });
    });
  }

  public setMetaTags(ogTitle: string) {
    this.metaService.addTag({ name: "og:title", content: ogTitle });
  }
}
